var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreensMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.38 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-screen-medium{fill:#7eac20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M86,90.86H63a4.11,4.11,0,0,1-4.11-4.11,3.32,3.32,0,0,1,3.32-3.32H86.81a3.32,3.32,0,0,1,3.32,3.32A4.11,4.11,0,0,1,86,90.86ZM62.24,86.43a.32.32,0,0,0-.32.32A1.11,1.11,0,0,0,63,87.86H86a1.1,1.1,0,0,0,1.1-1.11.32.32,0,0,0-.32-.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M121.5,86.43H42.7a1.5,1.5,0,0,1-1.5-1.5v-.14a1.5,1.5,0,0,1,1.5-1.5h73.15a.32.32,0,0,0,.33-.32V35.31a.33.33,0,0,0-.33-.33H36.9a.33.33,0,0,0-.33.33v31a1.5,1.5,0,0,1-1.5,1.5H29.43a1.5,1.5,0,0,1-1.5-1.5v-37A3.33,3.33,0,0,1,31.25,26H121.5a3.33,3.33,0,0,1,3.32,3.33V83.1A3.33,3.33,0,0,1,121.5,86.43Zm-2.36-3h2.36a.32.32,0,0,0,.32-.33V29.33a.32.32,0,0,0-.32-.33H31.25a.32.32,0,0,0-.32.33V64.79h2.64V35.31A3.33,3.33,0,0,1,36.9,32h78.95a3.34,3.34,0,0,1,3.33,3.33V83A2.38,2.38,0,0,1,119.14,83.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M115.85,86.29H42.7a1.5,1.5,0,0,1-1.5-1.5V69.94a2.15,2.15,0,0,0-2.14-2.15h-4a1.5,1.5,0,0,1-1.5-1.5v-31A3.33,3.33,0,0,1,36.9,32h78.95a3.34,3.34,0,0,1,3.33,3.33V83A3.33,3.33,0,0,1,115.85,86.29Zm-71.65-3h71.65a.32.32,0,0,0,.33-.32V35.31a.33.33,0,0,0-.33-.33H36.9a.33.33,0,0,0-.33.33V64.79h2.49a5.15,5.15,0,0,1,5.14,5.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M123.82,95.3H42.7a1.5,1.5,0,0,1-1.5-1.5V84.93a1.5,1.5,0,0,1,1.5-1.5h83.23a3.33,3.33,0,0,1,3.33,3.32v3.11A5.45,5.45,0,0,1,123.82,95.3Zm-79.62-3h79.62a2.45,2.45,0,0,0,2.44-2.44V86.75a.32.32,0,0,0-.33-.32H44.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M39.06,105.31H23.8a5.15,5.15,0,0,1-5.14-5.15V69.94a5.15,5.15,0,0,1,5.14-5.15H39.06a5.15,5.15,0,0,1,5.14,5.15v30.22A5.15,5.15,0,0,1,39.06,105.31ZM23.8,67.79a2.15,2.15,0,0,0-2.14,2.15v30.22a2.14,2.14,0,0,0,2.14,2.15H39.06a2.14,2.14,0,0,0,2.14-2.15V69.94a2.15,2.15,0,0,0-2.14-2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M42.7,71.79H20.16a.55.55,0,0,1,0-1.09H42.7a.55.55,0,0,1,0,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M42.7,72.41H20.16a1.17,1.17,0,1,1,0-2.33H42.7a1.17,1.17,0,1,1,0,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M42.7,99.89H20.16a.54.54,0,1,1,0-1.08H42.7a.54.54,0,1,1,0,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M42.7,100.52H20.16a1.17,1.17,0,1,1,0-2.33H42.7a1.17,1.17,0,1,1,0,2.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-screen-medium",
    d: "M34,69.22H28.81a.54.54,0,0,1,0-1.08H34a.54.54,0,1,1,0,1.08Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreensMedium);
export default __webpack_public_path__ + "static/media/screens-medium.8cb74c0f.svg";
export { ForwardRef as ReactComponent };